angular.module('picmonicng').filter('limitFrom', [
  function () {
    return function (input, index) {
      if (input) {
        return input.slice(parseInt(index, 10));
      }
    };
  },
]);
